export default __webpack_public_path__ + "static/media/listening.78963709.svg";